import { ProductInCategoryMapper } from './ProductInCategoryMapper';
import { ObjectMapper } from './ObjectMapper';

export class CategoryMapper {
    private static properties: Array<keyof Category> = ['id', 'name', 'index', 'products', 'previewPath'];

    static getCategoryFromData(categoryData: CategoryApi): Category {
        CategoryMapper.checkCategoryData(categoryData);
        const { id, name, index, products, labelList, previewPath, icon, iconUrl, favorite, favoriteRank } =
            categoryData;

        const category: Category = {
            id: (id as string) || '',
            name: (name as string) || '',
            index: (index as number) || 0,
            products: [],
            previewPath: (previewPath as string) || '',
            // Puces du tunnel : champs OPTIONNELS (backend plus ancien = absents),
            // d'où l'exclusion volontaire de `properties` / checkCategoryData.
            icon: icon || undefined,
            iconUrl: iconUrl || undefined,
            favorite: favorite === true,
            favoriteRank: typeof favoriteRank === 'number' ? favoriteRank : 0
        };
        category.products = CategoryMapper.getProductsFromData(products);
        const translatedName: string | undefined = ObjectMapper.getTranslatedName(labelList);
        category.name = translatedName || category.name;

        return category;
    }

    private static checkCategoryData(categoryData: CategoryApi): void {
        CategoryMapper.properties.forEach((prop) => {
            if (categoryData[prop] == null) {
                console.error(`Property ${prop} is missing or undefined in this category: ${categoryData.id}`);
            }
        });
    }

    private static getProductsFromData(products?: ProductInCategoryApi[]): ProductInCategory[] {
        if (!products) {
            console.error('Property products is missing or undefined in category');
            return [];
        }

        const productList: ProductInCategory[] = [];
        products?.forEach((product: ProductInCategoryApi) => {
            productList.push(ProductInCategoryMapper.getProductFromData(product));
        });

        return productList;
    }
}
